var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProductStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9617 1.60586L12.9009 5.53503C13.0567 5.85086 13.3584 6.07003 13.7076 6.12086L18.0434 6.75086C18.9217 6.87836 19.2734 7.95919 18.6367 8.57836L15.4992 11.6367C15.3749 11.758 15.2818 11.9077 15.2281 12.0728C15.1744 12.238 15.1616 12.4138 15.1909 12.585L15.9317 16.9034C16.0817 17.7792 15.1634 18.4459 14.3776 18.0334L10.4992 15.9942C10.3456 15.9133 10.1745 15.8711 10.0009 15.8711C9.82725 15.8711 9.65622 15.9133 9.50256 15.9942L5.62423 18.0334C4.83756 18.4459 3.91923 17.7792 4.06923 16.9034L4.81006 12.585C4.83923 12.4138 4.82642 12.2381 4.77271 12.0729C4.71901 11.9077 4.62602 11.758 4.50173 11.6367L1.36423 8.57836C0.728395 7.95919 1.07923 6.87836 1.95839 6.75086L6.29339 6.12086C6.64256 6.07003 6.94506 5.85086 7.10089 5.53503L9.03923 1.60586C9.43256 0.809195 10.5684 0.809195 10.9617 1.60586Z",
    fill: "#414B56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProductStar);
export default __webpack_public_path__ + "static/media/icon_product_star.e912ba12f21ddc43962eed60eda4c02b.svg";
export { ForwardRef as ReactComponent };